/**
 * Computes the react-table pageCount, handling the "unknown total" case
 * for endpoints that no longer return totalCount (count query dropped).
 *
 * react-table treats pageCount === -1 as "unknown", so next page always allowed.
 *
 * @param rowCount   number of rows returned for the current page (results.length)
 * @param size       page size (pageSize)
 * @param page       current page index (pageIndex)
 * @param totalCount total row count from the server, or null/undefined if dropped
 */

export function resolvePageCount(rowCount: number, size: number, page: number, totalCount?: number | null): number {
  if (totalCount == null) {
    return -1; // unknown; Next is driven by canNextPage in Table.tsx, not this
  }
  return totalCount > 0 ? Math.ceil(totalCount / size) : -1;
}
